export default __webpack_public_path__ + "static/media/diners.5fa7c30b.svg";